// extracted by mini-css-extract-plugin
module.exports = {"customSearch":"MegaMenu_customSearch__3-PoA","faCustom":"MegaMenu_faCustom__ZFlU3","itemList":"MegaMenu_itemList__9NUox"};